module.exports = __webpack_public_path__ + "static/img/3.56d130a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1314/3.png
// module id = 473
// module chunks = 1